<template>
  <v-app-bar class="defaultHeader" app height="120" flat>
    <v-spacer></v-spacer>

    <v-btn id="5" text rounded @click.prevent="logout()">Sair</v-btn>

    <v-btn
      v-on:click="$vuetify.theme.dark = !$vuetify.theme.dark"
      @click="mod($vuetify.theme.isDark)"
      icon
      class="mr-2 ml-2"
    >
      <v-icon>mdi-brightness-6</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "defaultHeader",

  methods: {
    ...mapActions({
      actionSingOut: "auth/actionSingOut"
    }),
    mod(opcao) {
      localStorage.setItem("dark", opcao);
    },
    logout() {
      this.actionSingOut();
      location.href = "/login";
    }
  },
  created() {
    var tema;
    if (localStorage.getItem("dark") == "true") {
      tema = true;
    } else {
      tema = false;
    }
    this.$vuetify.theme.dark = tema;
  }
};
</script>
